import ServiceTemplate from '@/components/ServiceTemplate';

export default function TaxAdvisory() {
  const data = {
    title: 'Tax Advisory Services',
    subtitle: 'Strategic tax planning and advisory services to minimize tax liability.',
    overviewTitle: 'Strategic Tax Planning for Your Business',
    overviewImage: 'https://images.unsplash.com/photo-1554224311-4e6eac1dc0a0',
    description: [
      'Effective tax planning can significantly reduce tax liability while ensuring compliance. Our tax advisory services provide strategic guidance for business structure, transactions, and ongoing operations.',
      'We analyze your business situation to identify tax-saving opportunities, optimize structure, and implement strategies that minimize tax burden while maintaining full compliance.',
      'Our experienced tax advisors stay current with changing tax laws to provide proactive advice that positions your business for tax efficiency.'
    ],
    benefits: [
      { title: 'Tax Minimization', description: 'Identify strategies to reduce tax liability.' },
      { title: 'Strategic Planning', description: 'Long-term tax planning aligned with business goals.' },
      { title: 'Entity Optimization', description: 'Select optimal business structure for tax purposes.' },
      { title: 'Transaction Support', description: 'Tax-efficient structuring of business transactions.' },
      { title: 'Compliance', description: 'Ensure compliance with all tax requirements.' },
      { title: 'Audit Support', description: 'Representation in tax audits and disputes.' }
    ],
    process: [
      { title: 'Discovery & Planning', description: 'Comprehensive assessment of your needs and strategic planning for optimal outcomes.' },
      { title: 'Documentation & Filing', description: 'Complete preparation and filing of all required documents with appropriate authorities.' },
      { title: 'Compliance & Support', description: 'Ongoing compliance monitoring, support, and strategic guidance as your needs evolve.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'When should I use tax advisory services?', answer: 'Consider tax advisory when starting a business, making major purchases, planning transactions, or seeking to reduce tax burden.' },
      { question: 'How much can tax planning save?', answer: 'Savings vary widely based on situation but proper planning can reduce taxes by thousands to millions depending on business size and complexity.' },
      { question: 'What is entity election optimization?', answer: 'Choosing the right entity type and tax elections (S Corp, C Corp, partnership) can significantly impact tax liability.' },
      { question: 'Do you handle tax preparation?', answer: 'We provide strategic advisory services and work with your tax preparer, or can provide full-service tax preparation and filing.' },
      { question: 'What about multi-state taxation?', answer: 'We advise on multi-state tax obligations including nexus analysis, apportionment, and state-specific planning strategies.' },
      { question: 'Can you help with international tax?', answer: 'Yes, we provide international tax planning for businesses with foreign operations, income, or transactions.' },
      { question: 'What is tax audit support?', answer: 'We represent clients in tax examinations, prepare responses to auditor inquiries, and negotiate settlements when necessary.' },
      { question: 'How often should tax planning be updated?', answer: 'Tax planning should be reviewed annually and whenever significant business changes occur or tax laws change.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
